namespace advisorop.components.servicer {

    export class UncategorizedSecuritiesMonitorController {
        advisoryFirmId: number;
        pageLen: number;
        issuesCount: number;

        allocationPlans: domains.ISecurityAllocationPlan[] = [];
        allocationPlan: domains.ISecurityAllocationPlan = {
            allocationPlanType: domains.AllocationPlanType.BO_SYSTEM_ALLOCATION_PLAN,
            allocations: []
        };
        advisoryFirms: Array<domains.IAdvisoryFirm> = [];
        selFirm: domains.IAdvisoryFirm;
        selAllocationPlan: domains.ISecurityAllocationPlan;
        nonAllocatedSecurities: domains.ISecurityAssetClass[];
        dg: DevExpress.ui.dxDataGridOptions;
        allowEditing = false;
        showStyleBased = false;

        dgRowsForSaving = [];
        dgNumOfRowsInValidation: number = 0;

        allocationRule: any = { type: "range", min: 0, max: 1, message: "Please enter value between 0 (0.00%) and 1 (100.00%)" };

        isInitializing: boolean = true;
        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#securitiesListContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading security asset class allocations...",
            bindingOptions: {
                visible: "vm.isInitializing"
            }
        }

        static $inject = ["servicerService", "generalService", "advisoryFirmApi"]
        constructor(private servicerService: services.ServicerService,
            private generalService: services.GeneralService,
            private advisoryFirmApi: services.AdvisoryFirmApi) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "Allocations"
                },
                bindingOptions: {
                    deep: true,
                    dataSource: "vm.nonAllocatedSecurities",
                    "columns[5].allowEditing": "vm.allowEditing",
                    "columns[6].allowEditing": "vm.allowEditing",
                    "columns[7].allowEditing": "vm.allowEditing",
                    "columns[8].allowEditing": "vm.allowEditing",
                    "columns[9].allowEditing": "vm.allowEditing",
                    "columns[10].allowEditing": "vm.allowEditing",
                    "columns[11].allowEditing": "vm.allowEditing",
                    "columns[10].visible": "vm.showStyleBased",
                    "columns[11].visible": "vm.showStyleBased",
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                //height: "4350px",
                paging: { enabled: true, pageSize: 50 },
                //scrolling: {
                //    useNative: true
                //},
                //height: "400px", 
                //paging: {
                //    enabled: false,
                //    pageSize: 225
                //},
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },
                editing: {
                    mode: "batch",
                    allowUpdating: true
                },

                columns: [
                    { dataField: "securityTicker", caption: "Ticker", allowEditing: false, width: 50 },
                    { dataField: "securityUniqueSecId", caption: "Unique Sec ID", allowEditing: false, width: 80 },
                    { dataField: "securityName", caption: "Name", allowEditing: false, width: 240 },
                    { dataField: "securitySecurityType", caption: "Sec Type", allowEditing: false, width: 110 },
                    { dataField: "securitySecurityCategory", caption: "Sec Category", allowEditing: false, width: 110 },
                    {
                        dataField: "equities", caption: "Equities",
                        format: { precision: 2, type: "percent" },
                        allowEditing: this.allowEditing, validationRules: [this.allocationRule],
                        minWidth: 45
                    },
                    {
                        dataField: "fixedIncome", caption: "Fixed Inc",
                        format: { precision: 2, type: "percent" },
                        allowEditing: this.allowEditing, validationRules: [this.allocationRule],
                        minWidth: 45
                    },
                    {
                        dataField: "alternativeAssets", caption: "Alt",
                        format: { precision: 2, type: "percent" },
                        allowEditing: this.allowEditing, validationRules: [this.allocationRule],
                        minWidth: 45
                    },
                    {
                        dataField: "cash", caption: "Cash",
                        format: { precision: 2, type: "percent" },
                        allowEditing: this.allowEditing, validationRules: [this.allocationRule],
                        minWidth: 45
                    },
                    {
                        dataField: "noAllocation", caption: "No Alloc",
                        format: { precision: 2, type: "percent" },
                        allowEditing: this.allowEditing, validationRules: [this.allocationRule],
                        minWidth: 45
                    },
                    {
                        dataField: "minEquity", caption: "Min Equity",
                        format: { precision: 2, type: "percent" },
                        allowEditing: this.allowEditing, validationRules: [this.allocationRule],
                        minWidth: 45,
                        visible: this.showStyleBased
                    },
                    {
                        dataField: "maxEquity", caption: "Max Equity",
                        format: { precision: 2, type: "percent" },
                        allowEditing: this.allowEditing, validationRules: [this.allocationRule],
                        minWidth: 45,
                        visible: this.showStyleBased
                    },
                ],
                // highlight the contents of the cell when the user clicks on it
                // this makes it easier to change the allocation (no backspace necessary)
                onEditorPreparing: (e) => {
                    if ((e.dataField == "equities" || e.dataField == "fixedIncome" ||
                        e.dataField == "alternativeAssets" || e.dataField == "cash" ||
                        e.dataField == "noAllocation" || e.dataField == "minEquity" ||
                        e.dataField == "maxEquity") && e.parentType == "dataRow") {
                        e.editorOptions.onFocusIn = function (args) {
                            args.element.find("input").select();
                        }
                    }
                },
                onRowUpdated: (e) => {
                    //const x: boolean = e.component.hasEditData();
                    //console.log(`onRowUpdated... Has edit data: ${x}`, e);
                },
                onRowInserted: (e) => {
                    //console.log(`onRowInserted...`, e);
                },
                onRowUpdating: (e) => {
                    // console.log(`onRowUpdating...`, e);

                    // at this point all changed rows are valid and ready to be saved
                    // but this method will fire for each changed row and we need to ensure that we call it only once
                    this.saveBatch(e.component);
                },
                onRowInserting: (e) => {
                    //console.log(`onRowInserting...`, e);
                },
                onRowValidating: (e) => {
                    //console.log(`onRowValidating...`, e);

                    if (!this.selAllocationPlan || !this.selFirm) {
                        e.isValid = false;
                        e.errorText = "Please select Advisory Firm and Allocation Plan";
                        toastr.error(e.errorText);
                        return;
                    }

                    // Add style based equity limits
                    let minEquity = (e.newData.minEquity || e.newData.minEquity === 0) ? e.newData.minEquity : ((e.oldData.minEquity || e.oldData.minEquity === 0) ? e.oldData.minEquity : 0);
                    let maxEquity = (e.newData.maxEquity || e.newData.maxEquity === 0) ? e.newData.maxEquity : ((e.oldData.maxEquity || e.oldData.maxEquity === 0) ? e.oldData.maxEquity : 0);

                    let equities = (e.newData.equities || e.newData.equities === 0) ? e.newData.equities : ((e.oldData.equities || e.newData.equities === 0) ? e.oldData.equities : 0);
                    let fixedIncome = (e.newData.fixedIncome || e.newData.fixedIncome === 0) ? e.newData.fixedIncome : ((e.oldData.fixedIncome || e.newData.fixedIncome === 0) ? e.oldData.fixedIncome : 0);
                    let alternativeAssets = (e.newData.alternativeAssets || e.newData.alternativeAssets === 0) ? e.newData.alternativeAssets : ((e.oldData.alternativeAssets || e.newData.alternativeAssets === 0) ? e.oldData.alternativeAssets : 0);
                    let cash = (e.newData.cash || e.newData.cash === 0) ? e.newData.cash : ((e.oldData.cash || e.newData.cash === 0) ? e.oldData.cash : 0);
                    let noAllocation = (e.newData.noAllocation || e.newData.noAllocation === 0) ? e.newData.noAllocation : ((e.oldData.noAllocation || e.newData.noAllocation === 0) ? e.oldData.noAllocation : 0);
                    let totalAllocation = (equities + cash + fixedIncome + alternativeAssets + noAllocation) * 100.0;
                    e.isValid = totalAllocation === 100;
                    if (!e.isValid) {
                        e.errorText = "Total allocation needs to be 100%. Current allocation is " + totalAllocation + "%";
                        toastr.error(e.errorText);
                        return;
                    }

                    // remember validated data which needs to be saved later in a batch
                    const alloc: domains.ISecurityAssetClass = {
                        ...e.key,
                        minEquity: minEquity,
                        maxEquity: maxEquity,
                        alternativeAssets: alternativeAssets,
                        cash: cash,
                        equities: equities,
                        fixedIncome: fixedIncome,
                        noAllocation: noAllocation,
                        securityAllocationPlanId: this.selAllocationPlan.id
                    };
                    this.dgRowsForSaving.push(alloc);
                }
            }
        };

        saveBatch = (dg: DevExpress.ui.dxDataGrid) => {
            if (this.dgRowsForSaving.length <= 0) {
                return;
            }

            dg.beginCustomLoading(`Saving data, please wait...`);

            this.servicerService.updateSecurityAssetClassAllocations(this.dgRowsForSaving)
                .then(response => {
                    toastr.success("Data has been successfully saved");
                    dg.endCustomLoading();
                },
                    err => {
                        dg.endCustomLoading();
                        this.generalService.showErrorWithMessage(`Unexpected error occurred. 
We need to reload the data grid and your changes will be lost. 
Sorry for this inconvenience.`, err);
                        this.loadAllocationPlan();
                    });

            this.dgRowsForSaving = [];
        }

        loadAllocationPlans(): void {
            if (this.selFirm) {
                this.servicerService.getSecurityAllocationPlans(this.selFirm.id)
                    .then(response => {
                        this.allocationPlans = response.data
                        let firmAllocationPlans = this.allocationPlans.filter(a => a.advisoryFirmId == this.selFirm.id);
                        if (firmAllocationPlans.length > 0) {
                            this.selAllocationPlan = firmAllocationPlans[0];
                        } else {
                            this.selAllocationPlan = this.allocationPlans[0];
                        }
                        this.loadAllocationPlan();
                    },
                        err => toastr.error("Error when trying to load allocation plans. ERROR " + err.status + " " + err.data))
            } else {
                this.allocationPlans = [];
            }
        };

        loadAllocationPlan(): void {
            if (this.selAllocationPlan) {
                this.isInitializing = true;
                this.servicerService.getSecurityAllocationPlan(this.selAllocationPlan.id)
                    .then(response => {
                        this.allocationPlan = response.data;
                        this.allowEditing = this.allocationPlan.allocationPlanType > 0;
                        this.showStyleBased = this.allocationPlan.styleBased;
                        this.nonAllocatedSecurities = this.allocationPlan.allocations.filter(c => c.noAllocation > 0.0);
                        this.issuesCount = this.nonAllocatedSecurities.length;
                        this.isInitializing = false;
                    },
                        err => {
                            toastr.error("Unexpected error when trying to load securities. ERROR " + err.status + " " + err.data);
                            this.isInitializing = false;
                        });
            }
            else {
                this.allocationPlan = {
                    allocations: []
                };
            }
        };

        useStyleBased(): void {
            this.allocationPlan.styleBased = this.showStyleBased;
            this.servicerService.updateSecurityAllocationPlan(this.allocationPlan.id, this.allocationPlan.styleBased)
                .then(response => {
                    //console.log("Updated style based")
                }, err => toastr.error("Unexpected error when trying tu change style based. ERROR " + err.status + " " + err.data));
        }

        firmCahnged(): void {
            this.advisoryFirmId = this.selFirm.id;
            this.loadAllocationPlans();
        }

        loadAdvisoryFirms(): void {
            this.advisoryFirmApi.getAdvisoryFirms()
                .then(response => {
                    this.advisoryFirms = response.data
                    this.selFirm = this.advisoryFirms[0];
                    this.firmCahnged();
                },
                    err => toastr.error("Error occured when loading advisory firms. ERROR " + err.status + " " + err.data));
        }

        $onInit(): void {
            this.loadAdvisoryFirms();
        }

        $onChanges(evt): void {
            for (var key in evt) {
            }
        }
    }


    class UncategorizedSecuritiesMonitor implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                advisoryFirmId: "<",
                pageLen: "<",
                issuesCount: "="
            };
            this.controller = UncategorizedSecuritiesMonitorController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/uncategorized-securities-monitor.html";
        }
    }
    angular.module(Constants.APP).component("uncategorizedSecuritiesMonitor", new UncategorizedSecuritiesMonitor());

}